import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import { Controller } from "react-hook-form";

export const FormInputMultiCheckbox = ({
  name,
  control,
  setValue,
  label,
  checkBoxoptions,
  defaultValue = [],
}) => {
  const [selectedItems, setSelectedItems] = useState(defaultValue || []);

  useEffect(() => {
    if (defaultValue && Array.isArray(defaultValue)) {
      setSelectedItems(defaultValue);
    }
  }, [defaultValue]);

  const handleSelect = (value) => {
    const isPresent = selectedItems.indexOf(value);
    if (isPresent !== -1) {
      const remaining = selectedItems.filter((item) => item !== value);
      setSelectedItems(remaining);
    } else {
      setSelectedItems((prevItems) => [...prevItems, value]);
    }
  };

  useEffect(() => {
    setValue(name, selectedItems);
  }, [selectedItems]);

  return (
    <FormControl sx={{ mt: 2 }} variant={"outlined"}>
      <FormLabel component="legend" sx={{ m: 0 }}>
        {label}
      </FormLabel>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {checkBoxoptions?.map((option) => {
          return (
            <FormControlLabel
              control={
                <Controller
                  name={name}
                  render={({}) => {
                    return (
                      <Checkbox
                        checked={selectedItems.includes(option.value)}
                        onChange={() => handleSelect(option.value)}
                      />
                    );
                  }}
                  control={control}
                />
              }
              label={option.label}
              key={option.value}
            />
          );
        })}
      </div>
    </FormControl>
  );
};
